// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1Ufvl","pageSection":"styles__pageSection___2khVH","tableDetail":"styles__tableDetail___2zZnR"};